import React, { useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import {
  generateStrongPassword,
  togglePasswordVisibility,
  copyPasswordToClipboard,
} from "./passwordUtils";

const ResetPassword: React.FC = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [enable2FA, setEnable2FA] = useState(false);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const query = new URLSearchParams(location.search);
  const token = query.get("token");
  const email = query.get("email");

  const apiUrl = process.env.REACT_APP_API_URL;

  const handleResetPassword = async () => {
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    try {
      await axios.post(`${apiUrl}/Admin/ResetPassword`, {
        email,
        token,
        newPassword,
        enable2FA,
      });
      alert("Password reset successfully");
      navigate("/login");
    } catch (error) {
      setError("Failed to reset password");
    }
  };

  return (
    <section className="reset-password-section">
      {error && <p style={{ color: "red" }}>{error}</p>}
      <div className="reset-password-form">
        <input
          className="reset-password-form__input"
          type={showPassword ? "text" : "password"}
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          placeholder="New Password"
        />
        <input
          className="reset-password-form__input"
          type={showPassword ? "text" : "password"}
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          placeholder="Confirm Password"
        />
        <div className="reset-checkbox-field">
          <input
            className="reset-password-checkbox"
            type="checkbox"
            checked={enable2FA}
            onChange={(e) => setEnable2FA(e.target.checked)}
          />
          <label className="reset-password-checkbox__label">
            Enable Two-Factor Authentication
          </label>
        </div>
        <div className="reset-form-button-section">
          <button
            className="reset-password-form__button reset-password-form__button--primary"
            onClick={handleResetPassword}
          >
            Reset Password
          </button>
          <button
            className="reset-password-form__button"
            onClick={() =>
              generateStrongPassword(
                setNewPassword,
                () => {},
                () => {}
              )
            }
          >
            Generate Strong Password
          </button>
          <button
            className="reset-password-form__button"
            onClick={() =>
              togglePasswordVisibility(showPassword, setShowPassword)
            }
          >
            {showPassword ? "Hide" : "Show"} Password
          </button>
          <button
            className="reset-password-form__button"
            onClick={() => copyPasswordToClipboard(newPassword)}
          >
            Copy Password
          </button>
        </div>
      </div>
    </section>
  );
};

export default ResetPassword;
